import React from 'react';
import { DEFAULT_ILLUSTRATION_SIZE } from './Illustration.constants';
import { IllustrationRoot } from './Illustration.styles';
const defaultProps = {
  size: DEFAULT_ILLUSTRATION_SIZE
};
export const Illustration = _ref => {
  let {
    illustrationComponent,
    size = DEFAULT_ILLUSTRATION_SIZE,
    ...restProps
  } = _ref;
  const ComponentName = illustrationComponent;
  return React.createElement(IllustrationRoot, {
    as: ComponentName,
    "data-test-id": restProps['data-test-id'] ?? illustrationComponent.__name,
    width: size,
    height: size,
    "aria-hidden": !restProps.title,
    "aria-label": restProps.title ?? illustrationComponent.__name,
    role: "img",
    "data-component": "Illustration"
  });
};